import { c as _c } from "react/compiler-runtime";
import { Text, Stack, colors } from '@newfront-insurance/core-ui';
import type { JSX } from 'react';
import styled from 'styled-components';
import type { ErrorMessageProps } from '../types';
const StyledPre = styled.pre`
  white-space: pre-wrap;
  word-break: break-word;
  background: ${colors.steel[50]};
  padding: 12px;
`;
const StyledContainer = styled.div`
  max-width: 550px;
  margin: 0 auto;
  padding: 80px 20px;
`;

/**
 * This component can be used to render a full page error message. It will fill the content area
 * of the page and centre the error message.
 */
export function ErrorMessage(t0) {
  const $ = _c(14);
  const {
    title,
    subtitle,
    icon,
    action,
    rawErrorMessage
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <Text textAlign="center"><strong>{title}</strong></Text>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== subtitle) {
    t2 = <Text textAlign="center">{subtitle}</Text>;
    $[2] = subtitle;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <Stack direction="vertical" gap={4} alignItems="center" justifyItems="center">{t1}{t2}</Stack>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== rawErrorMessage) {
    t4 = rawErrorMessage && <StyledPre>{rawErrorMessage}</StyledPre>;
    $[7] = rawErrorMessage;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== action || $[10] !== icon || $[11] !== t3 || $[12] !== t4) {
    t5 = <StyledContainer><Stack direction="vertical" gap={24} alignItems="center" justifyItems="center">{icon}{t3}{action}{t4}</Stack></StyledContainer>;
    $[9] = action;
    $[10] = icon;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}